export const MARTECH_BANNER_STONE_EXPERIMENT = 'martech_banner_on_map_in_commercial_for_sp_stone';

export const EXPERIMENTS: string[] = [MARTECH_BANNER_STONE_EXPERIMENT];
